"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContentMobile = void 0;
var _icons = require("@cian/ui-kit/icons");
var _typography = require("@cian/ui-kit/typography");
var styles = _interopRequireWildcard(require("./styles.css"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ModalContentMobile = props => {
  const {
    children,
    footer,
    showResetButton,
    onClose,
    onReset
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement("header", {
    className: styles['header']
  }, /*#__PURE__*/React.createElement("button", {
    "data-name": "BookingCalendarModalContent_CloseButton",
    type: "button",
    className: styles['close-button'],
    onClick: onClose
  }, /*#__PURE__*/React.createElement(_icons.IconClose16, null)), /*#__PURE__*/React.createElement(_typography.UIHeading4, null, "\u0414\u0430\u0442\u044B \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u044F"), showResetButton && /*#__PURE__*/React.createElement("button", {
    className: styles['reset-button'],
    "data-name": "BookingCalendarModalContent_ResetButton",
    type: "button",
    onClick: onReset
  }, /*#__PURE__*/React.createElement(_typography.ArticleParagraph1, {
    color: "primary_100"
  }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C"))), /*#__PURE__*/React.createElement("main", {
    className: styles['content']
  }, children), footer);
};
exports.ModalContentMobile = ModalContentMobile;